module.exports = __webpack_public_path__ + "static/4-equilibrio-e542fea8a37d63476fe8c8e64ebdcbce.jpg";